import Api from '_services/Api';
import { AxiosResponse } from 'axios';

export type MarketingTouchPayload = {
    anon_id: string;
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_content?: string;
    utm_term?: string;
    utm_placement?: string;
    utm_campaignid?: string;
    utm_adgroupid?: string;
    utm_creative?: string;
    landing_path?: string;
    referrer?: string;
    country_code?: string;
};

const MarketingTouchApi = {
    send: (
        payload: MarketingTouchPayload,
    ): Promise<AxiosResponse<{ ok: boolean }>> =>
        Api.post('marketing-touches', payload),
};

export default MarketingTouchApi;
